var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Configurer Landing Page")]),_c('router-link',{attrs:{"to":"/configure/account"}},[_vm._v("Create Account")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }